// extracted by mini-css-extract-plugin
export var button = "_e4-4";
export var hasDarkBackground = "_e4-7";
export var hasLightBackground = "_e4-6";
export var iconWrapper = "_e4-0";
export var large = "_e4-2";
export var medium = "_e4-1";
export var small = "_e4-5";
export var xsmall = "_e4-3";